import { MeasureLayout } from './MeasureLayout.mjs';

const layoutFeatures = {
    measureLayout: MeasureLayout,
};

export { layoutFeatures };
